class FitColorPicker extends HTMLElement {
  constructor() {
    super();

    this.promiseList = [];
    this.fitValues = [];
    this.relatedList = window.theme.related_prod_handles;
    this.currentFit = window.theme.current_prod.fit
      ? window.theme.current_prod.fit.toLowerCase()
      : null;
    this.currentColor = window.theme.current_prod.color.toLowerCase();
    this.currentColorName = window.theme.current_prod.color_name ? window.theme.current_prod.color_name.toLowerCase(): window.theme.current_prod.color.toLowerCase();
    this.currentFabric = window.theme.current_prod.fabric ? window.theme.current_prod.fabric.toLowerCase(): null;
    this.currentProd = window.theme.current_prod.prodInfo; 
    this.domain = `${Shopify.routes.root}`;
    this.allRelatedProducts = [];
    this.newColors = [];
    this.relatedProductsJson = {};
    this.seasonalColors = seasonal_colors;

    // loading screen
    this.loadingScreen = this.querySelector(".picker-load");

    // necessary containers to render swatches
    this.fitContainer = this.querySelector(".product-fit_picker-container");
    this.colorContainer = this.querySelector(".color_picker-colors-container");
    this.colorContainerSeasonal = this.querySelector(".seasonal-colors-container");

    // Variant form to reinitialize
    this.variantRadio = this.parentElement.querySelector("variant-radios");
    // Description tab to reinitialize
    this.descriptionTab = this.parentElement.querySelector("description-tab");
    // Alt description tab
    this.altdescriptionTab = this.parentElement.querySelector("alt-description-tab");
    // Product Images Slider to reinitialize
    this.prodImagesSlider = this.closest(".product").querySelector(
      "product-images-slider"
    );
    // Product page banner
    this.prodPageBanner = document.querySelector(".product-page__banner");
    this.prodPageBannerDescription = document.querySelector(
      ".product-page__banner-description"
    );

    // Product page price
    this.prodPagePrice = document.querySelector(
      ".product__info-container .price .price__regular"
    );
    this.prodPageSalePrice = document.querySelector(
      ".product__info-container .price .price__sale"
    );

    // Product Review Widget
    this.reviewWidget = document.querySelector(".yotpo.yotpo-main-widget");
    this.reviewStar = document.querySelector(".yotpo.bottomLine");

    // Preorder
    this.preorderMessage = document.querySelector(
      ".product-form .preorder-text"
    );
    this.init();
  }

  async init() {
    // Set current color in Color: part
    const activeColor = this.colorContainer
    .closest(".product-color_picker")
    .querySelector(".color_picker-header p span");
    activeColor.innerHTML = this.currentColorName.split("+").join(", ");
    activeColor.classList.remove("hidden");
    
    const handleColor = this.currentProd.handle.substring(this.currentProd.handle.indexOf('-') + 1);
    const seasonalContentColor = this.colorContainerSeasonal ? this.colorContainerSeasonal.closest(".product-color_picker").querySelector(".color_picker-header p span"): null;
    const contentColor = this.colorContainer.closest(".product-color_picker").querySelector(".color_picker-header p span");
    if (this.seasonalColors.includes(handleColor)) {
      if (seasonalContentColor) {
        seasonalContentColor.classList.remove('hidden');
        seasonalContentColor.innerHTML =
          this.currentColorName.split("+").join(", "); 
      }
    }

    // include current product as well, as a first element
    // this.relatedList.unshift(this.currentProd.handle);
    this.relatedList.forEach((rel_prod) => {
      this.promiseList = [
        ...this.promiseList,
        new Promise((resolve, reject) => { 
          fetch(`${this.domain}products/${rel_prod}.js`)
            .then((response) => response.json())
            .then((data) => {
              resolve(data);
            })
            .catch((err) => {
              reject(new Error("no product"));
            });
        }),
      ];
    });
    this.loadingScreen.classList.add("loading"); // turn on loading indicator
    this.allRelatedProducts = await Promise.all(
      this.promiseList.map((p) => p.catch((e) => e))
    );
    this.loadingScreen.classList.remove("loading"); // end of initial data loading
    this.showSwatches();
  }

  async showSwatches() {
    const fits = [];
    const colors = [];

    this.allRelatedProducts.forEach((prod) => {
      const tags = prod.tags;
      if (tags && tags.length > 0) {
        // breaks as soon as it finds fit
        const prodFit = this.findFit(tags);
       
        const prodFabric = this.findFabric(tags);
        console.log(this.currentFabric, prodFabric);
        
        // breaks as soon as it finds color
        const prodColorName = this.findProductColor(prod);
        const prodColor = this.findColor(tags);


        const colorAndFabric = prodColor + prodFabric;
        const thisColorAndFabric = this.currentColor + this.currentFabric;

        const fitAndFabric = prodFit + prodFabric;
        const thisFitAndFabric = this.currentFit + this.currentFabric;

        // Don't render duplicate fit - only render fits that have the same color as the current color
        prodFit && colorAndFabric === thisColorAndFabric
          ? fits.push({ prodFit, prod, prodFabric })
          : null;
        // Similar to the above
        prodColor && prodFit === this.currentFit 
          ? colors.push({ prodColor, prod, prodColorName , prodFabric })
          : null;
        

      }
    });
    this.renderFitSwatch(fits);
    this.renderColorSwatch(colors);

    // console.log("realtedProducts", this.relatedProductsJson);

    const colorSwatches = this.querySelectorAll(
      ".product-color_picker .color-picker"
    );
    // if(!this.detectMobile()) {
    //   this.querySelector(".color_picker-colors").addEventListener("mouseleave", this.onColorHoverOut.bind(this));
    // }
    colorSwatches.forEach((cswatch) => {
      if (!this.detectMobile()) {
        cswatch.addEventListener("mouseleave", this.onColorHoverOut.bind(this));
      }
    });
    colorSwatches.forEach((cswatch) => {
      cswatch.addEventListener("click", this.onColorClick.bind(this, cswatch));
      if (!this.detectMobile()) {
        cswatch.addEventListener(
          "mouseenter",
          this.onColorHover.bind(this, cswatch)
        );
      }
    });

    const fitSwatches = this.querySelectorAll(".product-fit__choice");
    fitSwatches.forEach((fswatch) => {
      fswatch.addEventListener("click", this.onFitClick.bind(this, fswatch));
    });

    // remove loading screen once swatch completes refreshing
    this.loadingScreen.classList.remove("loading");
    if (document.querySelector("product-pack")) {
      document.querySelector("product-pack").setColorByURL();
    }
  }

  // async getFitsData(){
  //   const scriptElement = document.querySelector('#data-url-fits');
  //   const url = scriptElement.getAttribute('data-url');
  //   await fetch(url)
  //     .then(response => {
  //       if (response.status === 200) {
  //         return response.json();
  //       } else {
  //         throw new Error('Invalid JSON');
  //       }
  //     })
  //     .then(data => {
  //       this.fitsTranslate = data[Shopify.locale] ? data[Shopify.locale]: null;
  //     })
  //     .catch(error => {
  //       console.error('Error: ', error);
  //     });
  // }

  detectMobile() {
    var isMobile = false; //initiate as false
    // device detection
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      isMobile = true;
    }
    return isMobile;
  }

  findFit(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("fit_")) {
        return tags[i].split("fit_")[1].toLowerCase();
      }
    }

    return null;
  }
  findFabric(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("fabric_")) {
        return tags[i].split("fabric_")[1].toLowerCase();
      }
    }
  }

  findColor(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("color_")) {
        return tags[i].split("color_")[1].toLowerCase();
      }
    }

    return null;
  }

  findProductColor(product){
    if(product.options[0].values[0]){
      return product.options[0].values[0];
    }
    return null;
  }

  renderFitSwatch(fits) {
    var isMercerFit = false;
    fits.forEach((fit) => {
      isMercerFit =
        fit.prodFit === "skinny" ||
        fit.prodFit === "slim" ||
        fit.prodFit === "straight"
          ? true
          : false;
    });
    fits = isMercerFit ? fits.reverse() : fits;
    const fitElements = fits.map((fit) => {
      this.relatedProductsJson[`${fit.prod.handle}`] = fit.prod;
      const fit_key = fit.prodFit.toLowerCase().replace(/\s+/g, '-');
      return `
          <div class="product-fit__choice ${
            fit.prodFit === this.currentFit ? "fit-active" : ""
          }"
                      data-fit="${fit.prodFit}"
                      data-variant-handle="${fit.prod.handle}">
            ${fit.prodFit}
          </div>
        `;
    });
    this.fitContainer.innerHTML = "";
    this.fitContainer.innerHTML = fitElements.join("");
    this.changeFitBreadcrumb();
  }
  changeFitBreadcrumb() {
    const breadcrumb = document.querySelector('.breadcrumb_pdp');
    if (breadcrumb) {
      breadcrumb.querySelector('span').textContent = this.currentFit;
    }
  }

  renderColorSwatch(colors) {
    const colorElements = this.getColors(colors);
    if (this.newColors.length > 0 && this.colorContainerSeasonal) {
      const colorElementsSeasonal = this.getColors(this.newColors);
      this.colorContainerSeasonal.innerHTML = "";
      this.colorContainerSeasonal.classList.add('hidden');
      this.colorContainerSeasonal.innerHTML = colorElementsSeasonal.join("");
      this.querySelector('.staple_text')?.classList.remove('hidden');
    }else if(this.querySelector('.seasonal-color_picker') && !this.querySelector('.seasonal-color_picker').classList.contains('hidden')) {
      this.querySelector('.seasonal-color_picker').classList.add('hidden');
    }
    this.newColors = [];
    this.colorContainer.innerHTML = "";
    this.colorContainer.classList.add('hidden');
    this.colorContainer.innerHTML = colorElements.join("");
    sortColors();
  }

  getColors(colors) {
    const colorElements = colors.map((color) => {
      this.relatedProductsJson[`${color.prod.handle}`] = color.prod;
      this.seasonalColors.includes(color.prod.handle) ? this.newColors.push(color): '';
      return `
        <div class="color-picker ${
          color.prodColor === this.currentColor && color.prodFabric == this.currentFabric ? "color-active" : ""
        } ${this.seasonalColors.includes(color.prod.handle) ? 'seasonal-color': ''}"
                    data-color="${color.prodColorName}"
                    data-variant-handle="${color.prod.handle}">
          <span class="color-picker__render ${color.prodColor
            .split("/ ")
            .join("-")
            .split(" ")
            .join("-")
            .split("+")
            .join("-")
            .split("/")
            .join("-")
            .split("+")
            .join("-")}"></span>
        </div>
      `;
    });
    return colorElements;
  }

  onColorHoverOut() {
    const activeSwatch = this.querySelector(
      ".product-color_picker .color-picker.color-active"
    );
    const colorValue = activeSwatch.dataset.color;
    activeSwatch
      .closest(".product-color_picker")
      .querySelector(".color_picker-header p span").innerHTML = colorValue;
    const SeasonalActiveSwatch = this.querySelector(
      ".product-color_picker.seasonal-color_picker .color-picker.color-active"
    );
    if (SeasonalActiveSwatch) {
      SeasonalActiveSwatch
      .closest(".product-color_picker")
      .querySelector(".color_picker-header p span").innerHTML = colorValue;
    }
    const clickedHandle = activeSwatch.dataset.variantHandle;
    const clickedProd = this.relatedProductsJson[clickedHandle];
    this.replaceProdPrice(clickedProd);
    if (this.prodImagesSlider) this.prodImagesSlider.reInitSlider(clickedProd);
  }

  onColorHover(clickedSwatch, event) {
    const activeSwatch = this.querySelector(
      ".product-color_picker .color-picker.color-active"
    );
    const clickedHandle = clickedSwatch.dataset.variantHandle;
    const clickedProd = this.relatedProductsJson[clickedHandle];
    this.replaceProdPrice(clickedProd);
    fontResize();
    if (clickedSwatch == activeSwatch) {
      return;
    }
    const colorValue = clickedSwatch.dataset.color;
    clickedSwatch
      .closest(".product-color_picker")
      .querySelector(".color_picker-header p span").innerHTML = colorValue;

    if (this.prodImagesSlider) this.prodImagesSlider.reInitSlider(clickedProd);
  }

  onColorClick(clickedSwatch, event) {
    event.preventDefault();

    const activeSwatch = this.querySelector(
      ".product-color_picker .color-picker.color-active"
    );
    const productForm = document.querySelector(".product-form");
    const addButton = document.querySelector(".product-form__submit");

    if (Object.is(clickedSwatch, activeSwatch)) {
      return;
    } else {
      activeSwatch.classList.remove("color-active");
      clickedSwatch.classList.add("color-active");

      const colorValue = clickedSwatch.dataset.color;
      if (clickedSwatch.closest(".product-color_picker").classList.contains('seasonal-color_picker')) {
        this.querySelector('.product-staple-colors').querySelector(".color_picker-header p span").classList.add('hidden');
      }else if(this.querySelector('.seasonal-color_picker')) {
        this.querySelector('.seasonal-color_picker').querySelector(".color_picker-header p span").classList.add('hidden');
      }
      clickedSwatch.closest(".product-color_picker")
        .querySelector(".color_picker-header p span").classList.remove('hidden');
      clickedSwatch
        .closest(".product-color_picker")
        .querySelector(".color_picker-header p span").innerHTML = colorValue;

      const clickedHandle = clickedSwatch.dataset.variantHandle;
      const clickedProd = this.relatedProductsJson[clickedHandle];
      predictProduct = clickedProd;
      // Extra code for Waitlist bug

      
      let tagsString = clickedProd.tags.join(',');
      console.log('tags', tagsString);
      let variantRadios = document.querySelector('variant-radios');
      variantRadios.dataset.waitlist = tagsString.includes('pdp_waitlist') ? 'true': 'false';
      variantRadios.dataset.tags = tagsString;
      

      const matchPreorder = clickedProd.tags.find((tag) => {
        if (tag == "preorder") {
          return true;
        }
      });
      let matchWaitlist = clickedProd.tags.find((tag) => {
        if (tag == "pdp_waitlist") {
          return true;
        }
      });

      if (
        productForm.dataset.waitlist &&
        productForm.dataset.waitlist == "true"
      ) {
        matchWaitlist = true;
      }

      if (this.preorderMessage) {
        this.preorderMessage.style.display = "none";
      }

      if (matchPreorder) {
        productForm.classList.add("preorder-template");
        //         addButton.innerHTML = 'Pre-Order';
      } else {
        productForm.classList.remove("preorder-template");
      }

      if (matchWaitlist) {
        productForm.classList.add("waitlist-template");
      } else {
      	productForm.classList.remove("waitlist-template"); 
      }

      // Replace the components
      if (this.variantRadio) this.variantRadio.reInitVariants(clickedProd);
      this.reInitSwatches(clickedHandle);

      if (this.descriptionTab)
        this.descriptionTab.reInitTabs(clickedProd.description);
      if (this.altdescriptionTab)
        this.altdescriptionTab.reInitTabs(clickedProd.description);
      if (this.prodImagesSlider)
        this.prodImagesSlider.reInitSlider(clickedProd);
      if (this.prodPageBanner || this.prodPageBannerDescription)
        this.replaceProdBanner(clickedHandle);
      this.replaceProdPrice(clickedProd);
      this.replaceTitle(clickedProd);
      
      this.replaceReview(clickedProd);

      // switch the url pathname with the corresponding product handle
      this.replaceHistoryState(clickedHandle);
      this.updateHandleSizeGuide(clickedHandle);
      this.renderStretchFactor(clickedHandle);
      
      // Update Pre-Order for new product (after a small delay to ensure variants are updated)
      if (window.updatePreOrderOnProductChange) {
        setTimeout(() => {
          window.updatePreOrderOnProductChange(clickedProd.handle, clickedProd.tags || []);
        }, 100);
      }
    }
  }
  replaceTitle(prod) {
    const titleContainer = document.querySelector(".product__title .title");
    if(titleContainer) titleContainer.textContent = prod.title;
  }

  renderStretchFactor(clickedHandle) {
    try {
        const json_stretch = document.querySelector("#blocks-data-stretch");
        const stretch_section = document.querySelector("#media-information");

        if (!json_stretch || !stretch_section) return;

        const stretchInformation = JSON.parse(json_stretch.textContent || "[]");
        const stretchActive = stretchInformation.find((stretch) => stretch.products.includes(clickedHandle));

        if (stretchActive) {
            stretch_section.querySelectorAll(".media-item.active")?.forEach((item) => {
                item.classList.remove("active");
            });
            
            stretch_section.querySelector(`.${stretchActive.stretch_factor}`)?.classList.add('active');
            stretch_section.querySelector('.media-subtitle').textContent = stretchActive.subtitle || "";
            stretch_section.querySelector('.section-description').textContent = stretchActive.description || "";
            stretch_section.querySelector('.stretch-image').src = stretchActive.svg_item || "";
        }
    } catch (error) {
        console.error("Error in renderStretchFactor:", error);
    }
  }

  onFitClick(clickedSwatch, event) {
    const activeSwatch = this.querySelector(".product-fit__choice.fit-active");
    const productForm = document.querySelector(".product-form");
    const addButton = document.querySelector(".product-form__submit");
    const noteInfo = document.querySelector('.note-info:not(.blue-jeans)');

    if (Object.is(clickedSwatch, activeSwatch)) {
      return;
    } else {
      activeSwatch.classList.remove("fit-active");
      clickedSwatch.classList.add("fit-active");

      const clickedHandle = clickedSwatch.dataset.variantHandle;
      if (clickedHandle.includes('sboy-') && noteInfo) {
        noteInfo.classList.remove('hidden');
      }else if (noteInfo) {
        noteInfo.classList.add('hidden');
      }
      const clickedProd = this.relatedProductsJson[clickedHandle];
      predictProduct = clickedProd;
      if (clickedProd.description.includes("<h2>Fit:</h2>")) {
        const productFeatures = clickedProd.description.split("</h2>")[1].split("<h2>")[0];
        // const productFeatures = clickedProd.description
        //   .split("<h2>Product Features:</h2>")[1]
        //   .split("<h2>Fit:</h2>")[0];
        const fitTexts = clickedProd.description.split("</h2>")[2].split("<h2>")[0];
        // const fitTexts = clickedProd.description
        //   .split("<h2>Product Features:</h2>")[1]
        //   .split("<h2>Fit:</h2>")[1]
        //   .split("<h2>Care:</h2>")[0];
        const careTexts = clickedProd.description.split("</h2>")[3].split("<h2>")[0];
        // const careTexts = clickedProd.description
        //   .split("<h2>Product Features:</h2>")[1]
        //   .split("<h2>Fit:</h2>")[1]
        //   .split("<h2>Care:</h2>")[1];
        const productFeaturesEl = document.querySelector('.panel-text__wrapper [data-index="1"]');
        if (productFeaturesEl) productFeaturesEl.innerHTML = productFeatures;
        const fitTextsEl = document.querySelector('.panel-text__wrapper [data-index="2"]');
        if (fitTextsEl) fitTextsEl.innerHTML = fitTexts;
        const careTextsEl = document.querySelector('.panel-text__wrapper [data-index="3"]');
        if (careTextsEl) careTextsEl.innerHTML = careTexts;
      } else {
        const productFeatures = clickedProd.description.split("</h2>")[1].split("<h2>")[0];
        // const productFeatures = clickedProd.description
        //   .split("<h2>Product Features:</h2>")[1]
        //   .split("<h2>Care:</h2>")[0];
        const careTexts = clickedProd.description.split("</h2>")[2].split("<h2>")[0];
        // const careTexts = clickedProd.description
        //   .split("<h2>Product Features:</h2>")[1]
        //   .split("<h2>Care:</h2>")[1];

        const productFeaturesEl = document.querySelector('.panel-text__wrapper [data-index="1"]');
        if (productFeaturesEl) productFeaturesEl.innerHTML = productFeatures;
        const careTextsEl = document.querySelector('.panel-text__wrapper [data-index="2"]');
        if (careTextsEl) careTextsEl.innerHTML = careTexts;
      }

      const matchPreorder = clickedProd.tags.find((tag) => {
        if (tag == "preorder") {
          return true;
        }
      });

      let matchWaitlist = clickedProd.tags.find((tag) => {
        if (tag == "pdp_waitlist") {
          return true;
        }
      });

      if (productForm.dataset.waitlist == "true") {
        matchWaitlist = true;
      }

      if (this.preorderMessage) {
        this.preorderMessage.style.display = "none";
      }

      if (matchPreorder) {
        productForm.classList.add("preorder-template");
      } else {
        productForm.classList.remove("preorder-template");
      }

      if (matchWaitlist) {
        productForm.classList.add("waitlist-template");
      } else {
        productForm.classList.remove("waitlist-template");
      }

      // change the title of the product (title changes with the fit name)
      clickedSwatch
        .closest(".product__info-container")
        .querySelector(".product__title .title").textContent =
        clickedProd.title;
      let metaTitle = document.querySelector('meta[property="og:title"]');
      let metaTwTitle = document.querySelector('meta[name="twitter:title"]');
      metaTitle.setAttribute(
        "content",
        `${document.querySelector("#gender__type").value} ${
          clickedProd.title
        } - Mott & Bow`
      );
      metaTwTitle.setAttribute(
        "content",
        `${document.querySelector("#gender__type").value} ${
          clickedProd.title
        } - Mott & Bow`
      );
      document.title = `${document.querySelector("#gender__type").value} ${
        clickedProd.title
      } - Mott & Bow`;
      let wrapper = document.querySelector(
        ".product__title-wrapper .title-type"
      );
      let title = document.querySelector(".product__title");

      //title.style.fontSize = parseInt(title.style.fontSize.replace('px', '')) + 1 + 'px';
      // Replace the components

      //change the this.variantRadio data-tags to the clicked product tags
      let tagsString = clickedProd.tags.join(',');
      console.log('tags', tagsString);
      this.variantRadio.dataset.tags = tagsString;
      
     
      
      if (this.variantRadio) this.variantRadio.reInitVariants(clickedProd);
      this.reInitSwatches(clickedHandle);

      if (this.descriptionTab)
        this.descriptionTab.reInitTabs(clickedProd.description);
      if (this.altdescriptionTab)
        this.altdescriptionTab.reInitTabs(clickedProd.description);
      if (this.prodImagesSlider)
        this.prodImagesSlider.reInitSlider(clickedProd);
      if (this.prodPageBanner || this.prodPageBannerDescription)
        this.replaceProdBanner(clickedHandle);
      let isBundle = document.querySelector("product-pack");
      if (!isBundle) {
        this.replaceProdPrice(clickedProd);
      } else {
        if (
          isBundle.querySelector(".pack-size__list input:checked").value == 1
        ) {
          this.replaceProdPrice(clickedProd);
        }
      }
      this.replaceReview(clickedProd);

      // switch the url pathname with the corresponding product handle
      this.replaceHistoryState(clickedHandle);
      this.updateHandleSizeGuide(clickedHandle);
      //wrapper.style.minHeight = '45px';
      title.style.fontSize = "3rem";
      fontResize();
      this.replaceBreadcrumb(clickedProd);
      
      // Update Pre-Order for new product (after a small delay to ensure variants are updated)
      if (window.updatePreOrderOnProductChange) {
        setTimeout(() => {
          window.updatePreOrderOnProductChange(clickedProd.handle, clickedProd.tags || []);
        }, 100);
      }
    }
    if (document.querySelector("product-pack")) {
      document.querySelector("product-pack").pickFit(clickedSwatch.dataset.fit);
    }
  }

  replaceBreadcrumb(product) {
    const breadcrumb = document.querySelector(".breadcrumb_pdp");
    if (!breadcrumb) return;
  
    const link = breadcrumb.querySelector("a");
    const span = breadcrumb.querySelector("span");
  
    if (!link || !span) return;
  
    let collectionUrl = product.type.toLowerCase();
    let collectionName = product.type.replace(/-/g, " ");
    let fitTag = "";
  
    product.tags.forEach(tag => {
      if (tag.startsWith("fit_")) {
        fitTag = tag.replace("fit_", "");
      }
      if (tag.startsWith("breadcrumb_")) {
        let breadcrumbValue = tag.replace("breadcrumb_", "");
        let parts = breadcrumbValue.split("__");
  
        collectionName = parts[0].replace(/-/g, " ").toUpperCase();
        collectionUrl = parts[1] ? parts[1] : parts[0];
      }
    });
  
    link.href = `/collections/${collectionUrl}`;
    link.textContent = collectionName;
    span.textContent = fitTag;
  }

  replaceHistoryState(prodHandle) {
    console.log("replacing history state...");
    history.replaceState("", {}, `${this.domain}products/${prodHandle}`);
  }

  updateHandleSizeGuide(prodHandle){
    const buttons = document.querySelectorAll('.pdp_size-guide');
    buttons.forEach((button) => {
      button.dataset.handle = prodHandle;
    });
  }

  reInitSwatches(handle) {
    // reinit the object fields to the corresponding product
    this.currentProd = this.relatedProductsJson[handle];
    this.currentFit = this.findFit(this.currentProd.tags);
    this.currentFabric = this.findFabric(this.currentProd.tags);
    this.currentColor = this.findColor(this.currentProd.tags);
    this.promiseList = [];

    this.showSwatches();
  }

  replaceReview(product) {
    this.reviewStar.dataset.productId = product.id;

    //let price = window.igData.price.getPriceByVariantId(product.variants[0].id);
    let price = product.variants[0].price;

    this.reviewWidget.dataset.productId = product.id;
    this.reviewWidget.dataset.name = product.title;
    this.reviewWidget.dataset.url = product.url;
    this.reviewWidget.dataset.imageUrl = product.featured_image;
    this.reviewWidget.dataset.price = price;
    this.reviewWidget.dataset.description = product.description;

    if(document.querySelector('.yotpo-bottomline')) {

      var yotpoApi = new Yotpo.API(yotpo);
      if(yotpoApi) yotpoApi.refreshWidgets();
    }
  }

  replaceProdBanner(handle) {
    let SMVariants = document.querySelector("v-variants");
    let SMProduct = document.getElementById("simple-bundles-options");
    // Bundles wrapper
    let bundleVariantsWrapper = document.querySelector(".variants-wrapper");
    //let itemProperty = document.getElementById('variantProperty');
    if (SMVariants) {
      SMVariants.querySelector(
        ".variants-wrapper"
      ).innerHTML = `<span class="button loading variants-loader"></span>`;
    }
    if (bundleVariantsWrapper) {
      bundleVariantsWrapper.innerHTML = `<span class="button loading variants-loader"></span>`;
    }
    fetch(`${this.domain}products/${handle}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newContent = parser.parseFromString(html, "text/html");
        if (SMProduct) {
          SMProduct.innerHTML = newContent.getElementById(
            "simple-bundles-options"
          ).innerHTML;
          // itemProperty.value = newContent.getElementById('variantProperty').value;
          SMVariants.update();
        }
        if (bundleVariantsWrapper) {
          bundleVariantsWrapper.innerHTML =
            newContent.querySelector(".variants-wrapper").innerHTML;
          bundleVariantsWrapper
            .querySelector("v-options")
            .checkSelectedOptions();
        }
        // console.log("new Content", newContent);

        const newPageBanner = newContent.querySelector(".product-page__banner");
        const newPageBannerDescription = newContent.querySelector(
          ".product-page__banner-description"
        );
        this.prodPageBanner.innerHTML = newPageBanner
          ? newPageBanner.innerHTML
          : this.newPageBanner.innerHTML;
        this.prodPageBannerDescription.innerHTML = newPageBannerDescription
          ? newPageBannerDescription.innerHTML
          : this.prodPageBannerDescription.innerHTML;
      });
      this.AbTestComparison(handle);
  }

  AbTestComparison(handle) {
    let elements = document.querySelectorAll(".ab-test-section");
    if (elements.length > 0) {
        elements.forEach(el => el.classList.add("hidden"));
    }
    let sections = document.querySelectorAll(`.test-content-${handle}`);
    if (sections.length > 0) {
      sections.forEach(el => el.classList.remove("hidden"));
  }
  }

  replaceProdPrice(prod) {
    let salePrice = this.prodPageSalePrice.querySelector(
      ".price-item.price-item--sale"
    );
    let oldPrice = this.prodPageSalePrice.querySelector(
      ".price-item.old-price"
    );
    let regularPrice = this.prodPagePrice.querySelector(".price-item--regular");
    if (prod.compare_at_price) {
      if (salePrice) {
        salePrice.textContent = `${window.theme.cart_currency_symbol} ` + Shopify.formatMoneyAmmount(prod.price / 100)+ " " + `${window.theme.shop_currency} `;
        salePrice.setAttribute("data-product-id", prod.id);
        if (document.querySelector("product-pack")) {
          document.querySelector(
            "#pack-1 + label .img-price .price"
          ).innerHTML = `${window.theme.cart_currency_symbol} ` + Shopify.formatMoneyAmmount(prod.price / 100);
        }
      }
      if (oldPrice) {
        oldPrice.textContent = `${window.theme.cart_currency_symbol} ` + prod.compare_at_price / 100 + " " + `${window.theme.shop_currency} `;
        oldPrice.setAttribute("data-product-id", prod.id);
      }
      this.prodPagePrice.style.display = "none";
      this.prodPageSalePrice.style.display = "flex";
    } else {
      //alert(regularPrice.textContent);
      if (regularPrice) {
        regularPrice.textContent = `${window.theme.cart_currency_symbol} ` + Shopify.formatMoneyAmmount(prod.price / 100)+ " " + `${window.theme.shop_currency} `;
        regularPrice.setAttribute("data-product-id", prod.id);
      }
      if (document.querySelector("product-pack")) {
        
          console.log("price ", regularPrice.textContent);
          let priceElement = document.querySelector("#pack-1 + label .img-price .price");
          if (priceElement && priceElement.hasAttribute("data-product-id")) {
            priceElement.setAttribute("data-product-id", prod.id);
          }
          priceElement.innerHTML = `${window.theme.cart_currency_symbol}` + Shopify.formatMoneyAmmount(prod.price / 100);
        
        //document.querySelector('#pack-1 + label .img-price .price').innerHTML = ' $' + (prod.price / 100) + ' ';
      }
      this.prodPageSalePrice.style.display = "none";
      this.prodPagePrice.style.display = "flex";
    }
    
  }
  
}

customElements.define("fit-color-picker", FitColorPicker);

function fitInOneLine(el) {
  let pricePack = document.querySelector(".pack-title__price");
  let priceUnit = document.querySelector(".price-item.price-item--regular");
  console.log(el.offsetHeight + ", " + window.getComputedStyle(el).fontSize);
  const MINIMUM_FONT_SIZE = 14;
  const MINIMUM_HEIGHT = 30;

  while (
    el.offsetHeight > MINIMUM_HEIGHT &&
    parseInt(window.getComputedStyle(el).fontSize) >= MINIMUM_FONT_SIZE
  ) {
    console.log("size changed");
    el.style.fontSize =
      parseInt(window.getComputedStyle(el).fontSize) - 1 + "px";
    pricePack.style.fontSize =
      parseInt(window.getComputedStyle(el).fontSize) - 1 + "px";
    priceUnit.style.fontSize =
      parseInt(window.getComputedStyle(el).fontSize) - 1 + "px";
  }
}

function fontResize() {
  let el = document.querySelector(".product__title");
  fitInOneLine(el);
}
window.addEventListener("DOMContentLoaded", () => {
  fontResize();
});
